import { FiatTransactionDepositResponse } from "@modules/shared/domain/entities/fiat-transaction-deposit-response.model";
import { ROUTER_OUTLET_NAME } from "@modules/+new/shared/universal-modal/entities/magic";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable()
export class HelpersService {
	constructor(private readonly router: Router) {}

	public redirect(currentStatus: FiatTransactionDepositResponse, baseUrl: string): void {
		let status = this.getRealStatus(currentStatus.payment_status, currentStatus.payment_error_code);
		this.router.navigateByUrl(`${baseUrl}/${status}(${ROUTER_OUTLET_NAME}:status/${status}`);
	}

	public getRealStatus(currentStatus: string, currentStatusReason: string): string {
		if (currentStatus === "cancel" || currentStatus === "fail" || currentStatus === "failure") {
			if (currentStatusReason === "paypal_email_mismatch") {
				return "email-mismatch";
			}
			return "fail";
		}
		if (
			currentStatus === "manual_approval" ||
			currentStatus === "potential_fraud" ||
			currentStatus === "pending" ||
			currentStatus === "success"
		) {
			return "success";
		}
	}
}
